module.exports = __webpack_public_path__ + "img/Physician - Light Gray - Selected.e788fc96.png";